import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../../components/dashboard/Layout";
import SearchBar from "../../../containers/admin/exams/searchbar";
import ExamsTable from "../../../containers/admin/exams/table";
import AddExamData from "../../../containers/admin/exams/models/add-exam-data";
import { getManualExamsRequest } from "../../../modules/admin-modules/exams/Actions";
import Questions from "../../../containers/admin/exams/models/questions";
import { getAllAdminSectionsRequest } from "../../../modules/admin-modules/sections/Actions";

const CenterExams = () => {
  const dispatch = useDispatch();
  const exams = useSelector((state) => state.exams.manualExams);
  const [isAdd, setAdd] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [examData, setExamData] = useState({});
  const [selectedSectionIds, setSelectedSectionIds] = useState([]);

  useEffect(() => {
    dispatch(getManualExamsRequest());
    dispatch(getAllAdminSectionsRequest());
  }, [dispatch]);

  const examList = Array.isArray(exams) ? exams : [];

  const filteredExams = useMemo(() => {
    if (!selectedSectionIds.length) return examList;

    return examList.filter((exam) =>
      exam?.chapters?.some((chapter) =>
        selectedSectionIds.some(
          (sectionId) => String(sectionId) === String(chapter?.section_id)
        )
      )
    );
  }, [examList, selectedSectionIds]);

  return (
    <Layout>
      <SearchBar
        title="اختبارات السنتر"
        setAdd={setAdd}
        setSelectedData={setSelectedData}
        selectedSectionIds={selectedSectionIds}
        setSelectedSectionIds={setSelectedSectionIds}
        examCount={filteredExams?.length ?? 0}
      />
      <AddExamData
        isAdd={isAdd}
        data={selectedData}
        setSelectedData={setSelectedData}
        setExamData={setExamData}
        fixedType="5"
        onSaved={() => dispatch(getManualExamsRequest())}
      />
      <ExamsTable
        setAdd={setAdd}
        setSelectedData={setSelectedData}
        exams={filteredExams}
      />
      <Questions
        examData={examData}
        selectedData={selectedData}
        isAdd={isAdd}
      />
    </Layout>
  );
};

export default CenterExams;
